import tenderThunks from "../features/tender_page/tender.thunk";
import * as pricingRequestThunk from "../features/pricing_request/PricingRequestStepper.thunk";

const rootThunks = {
	...tenderThunks,
	...pricingRequestThunk,
};

export default rootThunks;
